<template>
    <div id="ActivtyTask">
        <h1>Task Hareketleri </h1>
        <a-card class="activity-container">
            <div v-if="loading" class="loading-overlay">
                <div class="spinner"></div>
                <p>Yükleniyor...</p>
            </div>
            <div v-else-if="activities && activities.length" class="activity-list">
                <a-card v-for="activity in activities" :key="activity._id" class="activity-item">
                    <div class="activity-header">
                        <div class="user-info">
                            <Avatar
                                v-if="activity.actor === 'user'"
                                :size="25"
                                :src="usersMap[activity.actorUser] && usersMap[activity.actorUser].gravatar"
                                :username="usersMap[activity.actorUser] && usersMap[activity.actorUser].name"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="usersMap[activity.actorUser] && usersMap[activity.actorUser].email"
                            />
                            <Avatar
                                v-if="activity.actor === 'chatbot'"
                                :username="'Chatbot'"
                                class="avatar"
                                :src="baseUrl().concat('static/img/chatbot-bg.png')"
                            />

                            <Avatar
                                v-if="activity.actor === 'system'"
                                :username="'System'"
                                class="avatar"
                                :src="baseUrl().concat('static/img/minilogo4.png')"
                            />
                            <span class="user-name" v-if="activity.actor === 'user'">
                                {{ (usersMap[activity.actorUser] && usersMap[activity.actorUser].name) || "Bilinmeyen Kullanıcı" }}
                            </span>
                            <span class="user-name" v-if="activity.actor === 'chatbot'">
                                ChatBot
                            </span>
                            <span class="user-name" v-if="activity.actor === 'system'">
                                System
                            </span>
                        </div>
                        <span class="activity-time">
                            {{ $moment(activity.updatedAt).fromNow() }}
                        </span>
                    </div>

                    <div class="activity-content" v-html="getActivityContent(activity)"></div>
                </a-card>
            </div>
            <div v-else>
                <p>Herhangi bir hareket bulunamadı.</p>
            </div>
        </a-card>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Avatar from "vue-avatar";

export default {
    name: "ActivtyTask",
    components: {
        Avatar,
    },
    props: {
        taskId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            activities: null,
            loading: true,
        };
    },
    computed: {
        ...mapState({
            usersMap: function(state) {
                return state.user.users.data.reduce(function(acc, user) {
                    acc[user._id] = user;
                    return acc;
                }, {});
            },
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
        }),
    },
    methods: {
        ...mapActions({
            getTaskActivities: "tasks/getTaskActivities",
        }),
        async fetchActivities() {
            this.loading = true;
            try {
                const activities = await this.getTaskActivities(this.taskId);
                this.activities = activities;
            } catch (error) {
                console.error("Error fetching activities:", error);
            } finally {
                this.loading = false;
            }
        },
        baseUrl: () => {
            if (document.currentScript) {
                let _documentUrl = document.currentScript.src.split("/");
                return _documentUrl[0] + "//" + _documentUrl[2] + "/";
            } else {
                return "/";
            }
        },
        getActivityContent(activity) {
            let user = this.usersMap[activity.actorUser]?.name || "Bilinmeyen Kullanıcı";
            if (activity.actor === "system") {
                user = "Sistem";
            } else if (activity.actor === "chatbot") {
                user = "ChatBot";
            }
            const task = activity.payload.name;
            const oldStage = activity.payload.oldStage;
            const newStage = activity.payload.newStage;
            const oldPriority = activity.payload.oldPriority;
            const newPriority = activity.payload.newPriority;
            const taskTitle = activity.payload.taskTitle || "Bilinmeyen Görev";
            const tags = activity.payload.tags?.join(", ");

            switch (activity.type) {
                case "task-created":
                    return this.$t("notification.taskCreated", { user, task });
                case "task-stage-changed":
                    return this.$t("notification.taskStageChanged", { user, task, oldStage, newStage });
                case "task-assigned-to-user":
                    return `<strong>${user}</strong> kullanıcısı, ${activity.payload.assignees.map(assignee => `<strong>${assignee}</strong>`).join(", ")} kullanıcısını <strong>"${taskTitle}"</strong> adlı göreve atadı.`;
                case "task-update-priority":
                    return this.$t("notification.taskPriorityUpdated", { user, oldPriority, newPriority, taskTitle });
                case "task-added-tags":
                    return this.$t("notification.taskAddedTags", { user, taskTitle, tags });
                case "task-removed-tags":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevden şu etiketleri kaldırdı: <strong>${tags}</strong>.`;
                case "task-update-title":
                    return `<strong>${user}</strong> kullanıcısı görev başlığını <strong>"${activity.payload.oldTitle}"</strong> den <strong>"${activity.payload.newTitle}"</strong> olarak güncelledi.`;
                case "task-update-description":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin açıklamasını güncelledi.`;
                case "task-update-start-date":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin başlangıç tarihini <strong>"${activity.payload.oldStartDateFormatted}"</strong> den <strong>"${activity.payload.newStartDateFormatted}"</strong> olarak güncelledi.`;
                case "task-update-end-date":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin bitiş tarihini <strong>"${activity.payload.oldEndDateFormatted}"</strong> den <strong>"${activity.payload.newEndDateFormatted}"</strong> olarak güncelledi.`;
                case "task-update-owner":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin sahibini <strong>"${activity.payload.oldOwner}"</strong> den <strong>"${activity.payload.newOwner}"</strong> olarak değiştirdi.`;
                case "task-added-followers":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı göreve şu takipçileri ekledi: <strong>${activity.payload.followers?.join(", ")}</strong>.`;
                case "task-removed-followers":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevden şu takipçileri kaldırdı: <strong>${activity.payload.followers?.join(", ")}</strong>.`;
                case "task-added-collaborators":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı göreve şu işbirlikçileri ekledi: <strong>${activity.payload.collaborators?.join(", ")}</strong>.`;
                case "task-update-checklist":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevin kontrol listesini güncelledi. ${activity.payload.changeDescription || ""}`;
                case "task-added-subtask":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı göreve <strong>${activity.payload.subtaskCount}</strong> alt görev ekledi: <strong>${activity.payload.subtasks?.join(", ")}</strong>.`;
                case "task-removed-subtask":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı görevden <strong>${activity.payload.subtaskCount}</strong> alt görevi sildi: <strong>${activity.payload.subtasks?.join(", ")}</strong>.`;
                case "task-added-attachment":
                    return `<strong>${user}</strong> kullanıcısı <strong>"${taskTitle}"</strong> adlı göreve <strong>${activity.payload.attachmentCount}</strong> dosya ekledi: <strong>${activity.payload.attachments?.join(", ")}</strong>.`;
                case "task-completed":
                    return this.$t("notification.taskCompleted", { user, taskTitle });
                case "task-archived":
                    return this.$t("notification.taskArchived", { user, taskTitle });
                default:
                    return `${activity.type} - ${taskTitle}`;
            }
        },
    },
    created() {
        this.fetchActivities();
    },
};
</script>

<style lang="scss">
#ActivtyTask {
    .activity-container {
        max-height: 500px;
        overflow-y: auto;

        .activity-list {
            display: grid;
            gap: 12px;

            .activity-item {
                border-radius: 10px !important;
                border: 1px solid #e8e8e8 !important;

                .activity-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;

                    .user-info {
                        display: flex;
                        align-items: center;
                        gap: 8px;

                        .user-name {
                            font-weight: 500;
                        }
                    }

                    .activity-time {
                        font-size: 0.8em;
                        color: rgba(0, 0, 0, 0.45);
                    }
                }

                .activity-content {
                    font-size: 0.9em;
                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
    }

    .loading-overlay {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;

        .spinner {
            border: 4px solid rgba(0, 0, 0, 0.1);
            border-top: 4px solid #3498db;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }

        p {
            margin-top: 10px;
            font-size: 14px;
            color: #333;
        }
    }
}
.ant-card-bordered {
    border: none !important;
}
</style>
